import { render, staticRenderFns } from "./aifwxy.vue?vue&type=template&id=93e86546&scoped=true"
import script from "./aifwxy.vue?vue&type=script&lang=js"
export * from "./aifwxy.vue?vue&type=script&lang=js"
import style0 from "./aifwxy.vue?vue&type=style&index=0&id=93e86546&prod&lang=scss&scoped=true"
import style1 from "./aifwxy.vue?vue&type=style&index=1&id=93e86546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e86546",
  null
  
)

export default component.exports